import { ADMIN_PAGE_PATH } from '../constants/adminRoute';

export type BreadcrumbItem = { name: string; item: string };

function absUrl(origin: string, path: string): string {
  const normalized = path.startsWith('/') ? path : `/${path}`;
  try {
    return new URL(normalized, origin).href;
  } catch {
    return `${origin.replace(/\/$/, '')}${normalized}`;
  }
}

/**
 * BreadcrumbList JSON-LD（itemListElement 形式）
 */
export function buildBreadcrumbListSchema(items: BreadcrumbItem[]): Record<string, unknown> {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((it, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name: it.name,
      item: it.item,
    })),
  };
}

/** 記事詳細は `ArticleBreadcrumbJsonLd` でタイトル付きを出すため null */
export function getBreadcrumbsForPathname(pathname: string, origin: string): BreadcrumbItem[] | null {
  const p = pathname.replace(/\/$/, '') || '/';

  if (p === '/') {
    return null;
  }

  if (p.startsWith(`/${ADMIN_PAGE_PATH}`)) {
    return null;
  }

  if (p === '/articles') {
    return [
      { name: 'ホーム', item: absUrl(origin, '/') },
      { name: '旅行記事', item: absUrl(origin, '/articles') },
    ];
  }

  if (/^\/articles\/.+/.test(p)) {
    return null;
  }

  const staticLabels: Record<string, string> = {
    '/contact': 'お問い合わせ',
    '/terms': '利用規約',
    '/privacy': 'プライバシーポリシー',
    '/diagnosis': '旅行タイプ診断',
  };

  if (staticLabels[p]) {
    return [
      { name: 'ホーム', item: absUrl(origin, '/') },
      { name: staticLabels[p], item: absUrl(origin, p) },
    ];
  }

  if (p.startsWith('/diagnosis-result')) {
    return [
      { name: 'ホーム', item: absUrl(origin, '/') },
      { name: '診断結果', item: absUrl(origin, p) },
    ];
  }

  if (p.startsWith('/article-detail')) {
    return [
      { name: 'ホーム', item: absUrl(origin, '/') },
      { name: '旅行記事', item: absUrl(origin, '/articles') },
    ];
  }

  return [
    { name: 'ホーム', item: absUrl(origin, '/') },
    { name: 'ページ', item: absUrl(origin, p) },
  ];
}

export function buildArticleDetailBreadcrumbs(
  origin: string,
  pathname: string,
  articleTitle: string
): BreadcrumbItem[] {
  const normalized = pathname.startsWith('/') ? pathname : `/${pathname}`;
  return [
    { name: 'ホーム', item: absUrl(origin, '/') },
    { name: '旅行記事', item: absUrl(origin, '/articles') },
    { name: articleTitle, item: absUrl(origin, normalized) },
  ];
}
